import { Http, HttpResponse } from '@visiba/http';
import { ParameterHandler } from '@visiba/std';
import { Singleton } from '@visiba/instantiation';
import { HttpService, VisibaApiPromise } from '@services/http.service';
import { EnvironmentService } from '@services/environment.service/mod';
import type { IceServerModel } from './models/IceServerModel';
import type { TurnTestModel } from './models/TurnTestModel';

@Singleton()
export class GeneralApiService {
	constructor(
		private readonly httpService: HttpService,
		private readonly environmentService: EnvironmentService,
	) {
		// Empty
	}

	public async get(alias: string): VisibaApiPromise<number> {
		return this.httpService.get(`/general/licenceHolder/${alias}`);
	}

	// Not mapped correctly to httpService so using Http.get here instead.
	public async getIceServers(): Promise<HttpResponse<IceServerModel[]>> {
		return Http.get(`${this.environmentService.hosting.apiBaseUri}/General/MediaTest/iceServers`);
	}

	public async getFeatureToggles(urlAlias: string): VisibaApiPromise<Record<string, boolean>> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			urlAlias,
		});

		return this.httpService.get(`/general/featureToggles${parameterHandler.getString()}`);
	}

	public async turnTest(model: TurnTestModel): VisibaApiPromise<TurnTestModel> {
		return this.httpService.post<TurnTestModel>(
			`/General/TurnTest/Report/Participant/${model.ParticipantId}?protocol=${model.TurnProtocol}&port=${model.Port}&success=${model.Success}&timestamp=
	${model.Timestamp}`,
			null,
		);
	}
}
